// Pääskriptin IIFE-entry (buildataan /banner/vX.Y.Z/cmp.min.js:ksi V1-T3:ssa).
//
// Staattinen bundle ei voi saada domainia ja API-osoitetta palvelimella
// interpoloituna kuten vaihe 0:n edge-funktio, joten ne luetaan skriptitagista:
//   <script src="https://<proxy>/cmp/banner/v1.0.0/cmp.min.js?domain=example.fi"></script>
// - domain: oman src:n ?domain=-parametri tai data-cmp-domain-attribuutti
// - apiBase: data-cmp-api-attribuutti tai johdettu omasta src:stä
//   (kaikki /banner/-polkua edeltävä, esim. https://<proxy>/cmp)

import { initCmp } from './cmp';
import { deriveApiBase, parseDomainFromSrc } from './bootstrap';

(function () {
  'use strict';

  const script = document.currentScript as HTMLScriptElement | null;
  const src = script && script.src ? script.src : '';

  const domain = (src && parseDomainFromSrc(src)) || (script && script.getAttribute('data-cmp-domain')) || null;
  const apiBase = (script && script.getAttribute('data-cmp-api')) || (src && deriveApiBase(src)) || null;

  if (!domain) {
    console.warn('CMP: domain parameter required');
    return;
  }
  if (!apiBase) {
    console.warn('CMP: api base could not be resolved');
    return;
  }

  initCmp({ domain: domain, apiBase: apiBase });
})();
